var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFutureSegment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "500px",
    height: "500px",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Future Segment") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M249.932221,250.132991 L249.899707,250.085878 L249.894761,250.102862 L12.2368672,172.643761 C-20.1062022,271.919093 12.4751765,384.71579 100.373351,450.360931 L103.053854,452.335682 L249.932221,250.132991 Z",
    fill: "#055A60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFutureSegment);
export default __webpack_public_path__ + "static/media/Future-Segment.28cb190f8c81b566a2e3de614da0ba36.svg";
export { ForwardRef as ReactComponent };